import {
  defaultGapping,
  defaultLayouts,
  defaultTypography,
  GSEmptyList,
  GSItemList,
  useMediaQuery,
} from "golfstatus_react_components";
import SponsorListItem from "../events/event/sponsors/sponsor-list-item";

const AllSponsorsWidget = ({
  sponsorList,
  sponsorshipTier,
  eventDetailsView = false,
}) => {
  const { isPhone, isTablet } = useMediaQuery();

  const getEmptyListMessage = () => {
    return (
      <GSEmptyList
        style={{ ...defaultLayouts.fullWidth }}
        title="Sponsorships"
        detail="Become a sponsor today!"
        actions={[
          {
            title: "Sponsor this tournament",
            type: "black",
            onClick: () => {},
          },
        ]}
      />
    );
  };

  return eventDetailsView ? (
    <div style={{ ...defaultLayouts.vStack, ...defaultGapping.largeGap }}>
      <div style={{ ...defaultTypography.headline3 }}>
        {sponsorshipTier?.name}
      </div>
      <GSItemList
        type="inline-grid x-large-gap"
        style={{ ...defaultLayouts.fullWidth }}
        listStyle={{ ...defaultLayouts.fullWidth, alignItems: "flex-start" }}
        gridColumns={isTablet() ? 2 : isPhone() ? 1 : 3}
        items={sponsorList}
        listItem={(sponsorship) => (
          <SponsorListItem
            style={{ ...defaultLayouts.fullWidth }}
            {...sponsorship}
          />
        )}
        emptyMessage={getEmptyListMessage()}
      />
    </div>
  ) : (
    <GSItemList
      type="inline-grid x-large-gap"
      style={{ ...defaultLayouts.fullWidth }}
      listStyle={{ ...defaultLayouts.fullWidth, alignItems: "flex-start" }}
      gridColumns={isTablet() ? 2 : isPhone() ? 1 : 3}
      items={sponsorList}
      listItem={(sponsorship) => (
        <SponsorListItem
          style={{ ...defaultLayouts.fullWidth }}
          {...sponsorship}
        />
      )}
      emptyMessage={getEmptyListMessage()}
    />
  );
};

export default AllSponsorsWidget;
